module.exports = __webpack_public_path__ + "img/guide.c56a3a3b.webp";